module.exports = __webpack_public_path__ + "img/drainage-icon.597d1ed8.png";